import { T } from 'gt-react';

import { Checkbox } from '@/components/ui/checkbox';

/**
 * Opt-in write access. Off by default: a read-only connection can't be
 * steered into making changes by text the agent reads.
 */
export function WriteAccessToggle({
  checked,
  onCheckedChange,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}) {
  return (
    <label className="flex items-start gap-2 rounded-md border p-3 text-sm cursor-pointer">
      <Checkbox
        checked={checked}
        onCheckedChange={(value) => onCheckedChange(value === true)}
        className="mt-0.5"
      />
      <span className="flex flex-col gap-0.5">
        <span className="font-medium">
          <T context="Gently MCP consent: opt-in checkbox label for write access">
            Allow changes
          </T>
        </span>
        <span className="text-gray-500">
          <T context="Gently MCP consent: explains what write access allows">
            Create and cancel tasks, trigger workflows, and start or cancel
            agent runs. Leave off to connect read-only.
          </T>
        </span>
      </span>
    </label>
  );
}
